import * as React from 'react';
import { useContext, useEffect, useRef } from 'react';
import DatePicker from '../../../../new_design/common/search_widget/date-picker';
import { useDefaultDatesRange } from '../../lib/default_dates_range_context';
import { SearchDataContext } from '../../lib/search_data_context';

export const DatesPicker = ({ formId }) => {
  const datePickerId = `${formId}-dates-range`;

  const datePicker = useRef(null);

  const { onChangeDates } = useContext(SearchDataContext);
  const [dateStartDefault, dateEndDefault] = useDefaultDatesRange();

  const handleDatesChanged = () => {
    onChangeDates(datePicker.current?.getStart(), datePicker.current?.getEnd());
  };

  useEffect(() => {
    datePicker.current = new DatePicker(`${datePickerId}-wrapper`, {
      dateStart: `#${formId}-date-start`,
      dateEnd: `#${formId}-date-end`,
      dateRange: `#${datePickerId}`,
      firstPreview: false,
      onUpdate: handleDatesChanged,
      dayWidth: 39
    });

    datePicker.current.init();
    datePicker.current.updateDatesOutside({ startDate: dateStartDefault, endDate: dateEndDefault });
  }, []);

  return (
    <div className={'text_field search-data-popup__dates-picker'} id={`${datePickerId}-wrapper`}>
      <div className={'text_field__wrapper text_field-size_default text_field-filled'}>
        <div className={'text_field__icon'}></div>
        <div className={'text_field__input_wrapper'}>
          <input hidden name={'date_start'} id={`${formId}-date-start`} />
          <input hidden name={'date_end'} id={`${formId}-date-end`} />
          <input className={'text_field__input'} name={'dates'} id={datePickerId} readOnly />
          <div className={'text_field__placeholder'}>Даты поездки</div>
        </div>
      </div>
    </div>
  );
};
